var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.show)?_c('b-card',{staticClass:"notFound"},[_c('img',{attrs:{"src":require("../../public/notFound.png"),"alt":"","width":"150px"}}),_c('h1',{staticStyle:{"font-size":"80px"}},[_vm._v("Oops!")]),_c('h3',{staticClass:"message"},[_vm._v(" "+_vm._s(_vm.message)+" ")])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }